import { Plugins } from '@leverege/plugin';
import { AreaSeries, AreaStack, BarGroup, BarSeries, BarStack, LineSeries } from '@visx/xychart';
import CoordinateCreatorPlugins from "./attribute/CoordinateCreator.js";
import AttributePluginSetup from "./attribute/PluginSetup.js";
import ModelPlugins from "./models/PluginSetup.js";
import { AttributeCoordinateModel, BandScaleModel, LinearScaleModel, TimeScaleModel, UnitAttributeCoordinateModel, XYChartModel, PieChartModel, LineSeriesModel, BarSeriesModel, AreaSeriesModel, AreaStackSeriesModel, BarStackSeriesModel, BarGroupSeriesModel, UTCScaleModel, GlyphLineSeriesModel, DotGlyphModel, SquareGlyphModel, TextGlyphModel, ValueGlyphSymbolizer, ValueGlyphSymbolizerEditor, SolidGraphBackgroundModel, StripedGraphBackgroundModel, ImageGraphBackgroundModel, ValueRangeModel } from "./models/index.js";
import { GlyphLineSeries, DotGlyphRenderer, SquareGlyphRenderer, TextGlyphRenderer, XYChartRenderer, PieChartRenderer, SolidGraphBackground, StripedGraphBackground, ImageGraphBackground } from "./viewers/index.js";
import { XYChartModelEditor, PieChartModelEditor, AttributeCoordinateEditor, UnitAttributeCoordinateEditor, LineSeriesEditor, BarSeriesEditor, AreaSeriesEditor, BarStackSeriesEditor, GlyphLineSeriesEditor, DotGlyphEditor, TextGlyphEditor, SquareGlyphEditor, SolidGraphBackgroundEditor, StripedGraphBackgroundEditor, ImageGraphBackgroundEditor, LinearScaleEditor, BandScaleEditor, TimeScaleEditor, ValueRangeEditor } from "./editors/index.js";
const modelTypes = ['SeriesModel', 'ScaleModel', 'GlyphModel', 'GraphBackgroundModel'];
const editorTypes = ['SeriesModelEditor', 'ScaleModelEditor', 'GlyphModelEditor', 'GraphBackgroundModelEditor'];
modelTypes.forEach(type => {
  Plugins.on(type, evt => {
    if (evt.type === 'pluginAdded') {
      Plugins.add('Model', evt.plugin);
    }
    if (evt.type === 'pluginRemoved') {
      Plugins.remove('Model', evt.plugin);
    }
  });
});
editorTypes.forEach(type => {
  Plugins.on(type, evt => {
    if (evt.type === 'pluginAdded') {
      Plugins.add('ModelEditor', evt.plugin);
    }
    if (evt.type === 'pluginRemoved') {
      Plugins.remove('ModelEditor', evt.plugin);
    }
  });
});
export default {
  install(opts) {
    AttributePluginSetup.install(opts);
    CoordinateCreatorPlugins.install(opts);
    ModelPlugins.install(opts);

    // Graph types
    Plugins.add('Model', {
      type: XYChartModel.TYPE,
      model: XYChartModel
    });
    Plugins.add('ModelEditor', {
      type: XYChartModel.TYPE,
      editor: XYChartModelEditor
    });
    Plugins.add('Graph', {
      type: XYChartModel.TYPE,
      graph: XYChartRenderer
    });
    Plugins.add('Model', {
      type: PieChartModel.TYPE,
      model: PieChartModel
    });
    Plugins.add('ModelEditor', {
      type: PieChartModel.TYPE,
      editor: PieChartModelEditor
    });
    Plugins.add('Graph', {
      type: PieChartModel.TYPE,
      graph: PieChartRenderer
    });

    // Coordinate types
    Plugins.add('Model', {
      type: AttributeCoordinateModel.TYPE,
      model: AttributeCoordinateModel
    });
    Plugins.add('ModelEditor', {
      type: AttributeCoordinateModel.TYPE,
      editor: AttributeCoordinateEditor
    });
    Plugins.add('Model', {
      type: UnitAttributeCoordinateModel.TYPE,
      model: UnitAttributeCoordinateModel
    });
    Plugins.add('ModelEditor', {
      type: UnitAttributeCoordinateModel.TYPE,
      editor: UnitAttributeCoordinateEditor
    });

    // Value range
    Plugins.add('Model', {
      type: ValueRangeModel.TYPE,
      model: ValueRangeModel
    });
    Plugins.add('ModelEditor', {
      type: ValueRangeModel.TYPE,
      editor: ValueRangeEditor
    });

    // 
    // Scale types
    Plugins.add('ScaleModel', {
      type: LinearScaleModel.TYPE,
      get name() {
        return LinearScaleModel.name;
      },
      model: LinearScaleModel
    });
    Plugins.add('ScaleModelEditor', {
      type: LinearScaleModel.TYPE,
      editor: LinearScaleEditor
    });
    Plugins.add('ScaleModel', {
      type: BandScaleModel.TYPE,
      get name() {
        return BandScaleModel.name;
      },
      model: BandScaleModel
    });
    Plugins.add('ScaleModelEditor', {
      type: BandScaleModel.TYPE,
      editor: BandScaleEditor
    });
    Plugins.add('ScaleModel', {
      type: TimeScaleModel.TYPE,
      get name() {
        return TimeScaleModel.name;
      },
      model: TimeScaleModel
    });
    Plugins.add('ScaleModelEditor', {
      type: TimeScaleModel.TYPE,
      editor: TimeScaleEditor
    });
    Plugins.add('ScaleModel', {
      type: UTCScaleModel.TYPE,
      get name() {
        return UTCScaleModel.name;
      },
      model: UTCScaleModel
    });
    Plugins.add('ScaleModelEditor', {
      type: UTCScaleModel.TYPE,
      editor: TimeScaleEditor
    });

    // Series types
    Plugins.add('SeriesModel', {
      type: LineSeriesModel.TYPE,
      get name() {
        return LineSeriesModel.name;
      },
      model: LineSeriesModel
    });
    Plugins.add('SeriesModelEditor', {
      type: LineSeriesModel.TYPE,
      editor: LineSeriesEditor
    });
    Plugins.add('SeriesRenderer', {
      type: LineSeriesModel.TYPE,
      renderer: LineSeries
    });
    Plugins.add('SeriesModel', {
      type: AreaSeriesModel.TYPE,
      get name() {
        return AreaSeriesModel.name;
      },
      model: AreaSeriesModel
    });
    Plugins.add('SeriesModelEditor', {
      type: AreaSeriesModel.TYPE,
      editor: AreaSeriesEditor
    });
    Plugins.add('SeriesRenderer', {
      type: AreaSeriesModel.TYPE,
      renderer: AreaSeries
    });
    // Plugins.add( 'SeriesModel', { type : AreaStackSeriesModel.TYPE, name : AreaStackSeriesModel.name, model : AreaStackSeriesModel } )
    // Plugins.add( 'SeriesModelEditor', { type : AreaStackSeriesModel.TYPE, editor : AreaSeriesEditor } )
    // Plugins.add( 'SeriesRenderer', { type : AreaStackSeriesModel.TYPE, renderer : AreaSeries, container : AreaStack } )
    Plugins.add('SeriesModel', {
      type: BarSeriesModel.TYPE,
      get name() {
        return BarSeriesModel.name;
      },
      model: BarSeriesModel
    });
    Plugins.add('SeriesModelEditor', {
      type: BarSeriesModel.TYPE,
      editor: BarSeriesEditor
    });
    Plugins.add('SeriesRenderer', {
      type: BarSeriesModel.TYPE,
      renderer: BarSeries
    });
    // Plugins.add( 'SeriesModel', { type : BarStackSeriesModel.TYPE, name : BarStackSeriesModel.name, model : BarStackSeriesModel } )
    // Plugins.add( 'SeriesModelEditor', { type : BarStackSeriesModel.TYPE, editor : BarStackSeriesEditor } )
    // Plugins.add( 'SeriesRenderer', { type : BarStackSeriesModel.TYPE, renderer : BarSeries, container : BarStack } )
    // Plugins.add( 'SeriesModel', { type : BarGroupSeriesModel.TYPE, name : BarGroupSeriesModel.name, model : BarGroupSeriesModel } )
    // Plugins.add( 'SeriesModelEditor', { type : BarGroupSeriesModel.TYPE, editor : BarSeriesEditor } )
    // Plugins.add( 'SeriesRenderer', { type : BarGroupSeriesModel.TYPE, renderer : BarSeries, container : BarGroup } )
    Plugins.add('SeriesModel', {
      type: GlyphLineSeriesModel.TYPE,
      get name() {
        return GlyphLineSeriesModel.name;
      },
      model: GlyphLineSeriesModel
    });
    Plugins.add('SeriesModelEditor', {
      type: GlyphLineSeriesModel.TYPE,
      editor: GlyphLineSeriesEditor
    });
    Plugins.add('SeriesRenderer', {
      type: GlyphLineSeriesModel.TYPE,
      renderer: GlyphLineSeries
    });

    // Glyph types
    Plugins.add('GlyphModel', {
      type: DotGlyphModel.TYPE,
      get name() {
        return DotGlyphModel.name;
      },
      model: DotGlyphModel
    });
    Plugins.add('GlyphModelEditor', {
      type: DotGlyphModel.TYPE,
      editor: DotGlyphEditor
    });
    Plugins.add('GlyphRenderer', {
      type: DotGlyphModel.TYPE,
      renderer: DotGlyphRenderer
    });
    Plugins.add('GlyphModel', {
      type: SquareGlyphModel.TYPE,
      get name() {
        return SquareGlyphModel.name;
      },
      model: SquareGlyphModel
    });
    Plugins.add('GlyphModelEditor', {
      type: SquareGlyphModel.TYPE,
      editor: SquareGlyphEditor
    });
    Plugins.add('GlyphRenderer', {
      type: SquareGlyphModel.TYPE,
      renderer: SquareGlyphRenderer
    });
    Plugins.add('GlyphModel', {
      type: TextGlyphModel.TYPE,
      get name() {
        return TextGlyphModel.name;
      },
      model: TextGlyphModel
    });
    Plugins.add('GlyphModelEditor', {
      type: TextGlyphModel.TYPE,
      editor: TextGlyphEditor
    });
    Plugins.add('GlyphRenderer', {
      type: TextGlyphModel.TYPE,
      renderer: TextGlyphRenderer
    });
    Plugins.add('Model', {
      type: ValueGlyphSymbolizer.TYPE,
      model: ValueGlyphSymbolizer
    });
    Plugins.add('ModelEditor', {
      type: ValueGlyphSymbolizer.TYPE,
      editor: ValueGlyphSymbolizerEditor
    });
    Plugins.add('GlyphSymbolizer', {
      type: ValueGlyphSymbolizer.TYPE,
      name: 'Value Symbolizer',
      symbolizer: ValueGlyphSymbolizer
    });
    Plugins.add('GraphBackgroundModel', {
      type: SolidGraphBackgroundModel.TYPE,
      get name() {
        return SolidGraphBackgroundModel.name;
      },
      model: SolidGraphBackgroundModel
    });
    Plugins.add('GraphBackgroundModel', {
      type: StripedGraphBackgroundModel.TYPE,
      get name() {
        return StripedGraphBackgroundModel.name;
      },
      model: StripedGraphBackgroundModel
    });
    Plugins.add('GraphBackgroundModel', {
      type: ImageGraphBackgroundModel.TYPE,
      get name() {
        return ImageGraphBackgroundModel.name;
      },
      model: ImageGraphBackgroundModel
    });
    Plugins.add('GraphBackgroundModelEditor', {
      type: SolidGraphBackgroundModel.TYPE,
      editor: SolidGraphBackgroundEditor
    });
    Plugins.add('GraphBackgroundModelEditor', {
      type: StripedGraphBackgroundModel.TYPE,
      editor: StripedGraphBackgroundEditor
    });
    Plugins.add('GraphBackgroundModelEditor', {
      type: ImageGraphBackgroundModel.TYPE,
      editor: ImageGraphBackgroundEditor
    });
    Plugins.add('GraphBackgroundRenderer', {
      type: SolidGraphBackgroundModel.TYPE,
      renderer: SolidGraphBackground
    });
    Plugins.add('GraphBackgroundRenderer', {
      type: StripedGraphBackgroundModel.TYPE,
      renderer: StripedGraphBackground
    });
    Plugins.add('GraphBackgroundRenderer', {
      type: ImageGraphBackgroundModel.TYPE,
      renderer: ImageGraphBackground
    });
  }
};